/* ============================================================================
   HDZS · free-form bundle builder ("pick any products") — builder agent, wave 4. Vanilla ES5, no libraries.
   Markup: sections/hdzs-bundle.liquid + snippets/hdzs-bcard.liquid ([data-hdzs-bundle]).
   Depends on window.HDZB (hdzb.js: money, cart, lockScroll, trapFocus) and window.HDZS (hdzs.js v1.3.1: evaluate, canProject,
   codeState, paintTrack, addSet, tiers) — both loaded `defer` by the layout before this file.
   · Cards: one product each, variant controls, "Add to bundle" ⇄ "Added · Remove". Changing a variant of an added card updates its line.
   · Panel: tier track with both milestones, picked lines + empty slots up to 3, subtotal / Buy 1 Get 1 / bundle saving / total,
     ONE /cart/add.js for all lines → the engine applies the tier code → UpCart refreshes and opens.
   · Honest money: the bundle saving is subtracted only when HDZS.canProject(code) (code confirmed this session or Theme setting
     "codes exist"); otherwise a neutral note. The projection includes items already in the cart (that is how the cart will judge it).
   · Memory: localStorage 'hdzs_bundle' {at, items:[{id, q}]} (14 days, try/catch). Quiz hand-off: ?bundle=<variantId>[x<qty>],…
     (variants of the deal reel become the Buy 1 Get 1 pair line). Cleared after a successful add.
   ========================================================================== */
(function () {
  'use strict';
  function H() { return window.HDZB; }
  function E() { return window.HDZS; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }
  function money(c) { return H() && H().money ? H().money(c) : '$' + (c / 100).toFixed(2); }
  function moneyT(c) { return H() && H().money ? H().money(c, { trim: true }) : '$' + (c / 100).toFixed(2); }
  function fill(t, v) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; }); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var MQ = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true, addListener: function () { } };
  function bump(n) { if (!n || RM) return; n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); }
  function headerH() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdzb-header-h')); return isNaN(v) ? 64 : v; }
  var SVG = {
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>'
  };
  function icon(k, size, sw) { return '<svg class="hdzb-i" viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" stroke="currentColor" stroke-width="' + (sw || 2.5) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + SVG[k] + '</svg>'; }

  /* ---------- memory ---------- */
  var KEY = 'hdzs_bundle', TTL = 14 * 864e5;
  function ls() { try { return window.localStorage; } catch (e) { return null; } }
  function load() { try { var s = ls(), d = s && JSON.parse(s.getItem(KEY) || 'null'); if (d && d.items && d.items.length && Date.now() - (d.at || 0) < TTL) return d.items; } catch (e) { } return null; }
  function save(items) { try { var s = ls(); if (!s) return; if (!items || !items.length) s.removeItem(KEY); else s.setItem(KEY, JSON.stringify({ at: Date.now(), items: items })); } catch (e) { } }
  /* ?bundle=123x2,456 → [{id:123,q:2},{id:456,q:1}]; the parameter is removed from the address bar afterwards */
  function readParam() {
    var m = /[?&]bundle=([^&#]*)/.exec(window.location.search);
    if (!m) return null;
    var list = decodeURIComponent(m[1]).split(',').map(function (x) { var p = x.split('x'); return { id: Number(p[0]), q: Math.max(1, Math.min(4, Number(p[1]) || 1)) }; }).filter(function (x) { return x.id > 0; });
    try {
      var rest = window.location.search.replace(/([?&])bundle=[^&#]*(&|$)/, '$1').replace(/[?&]$/, '');
      window.history.replaceState(window.history.state, '', window.location.pathname + rest + window.location.hash);
    } catch (e) { }
    return list;
  }
  /* "handle | preselected variant | hide, hide" per line */
  function parseRules(txt) {
    var out = {};
    String(txt || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|').map(function (x) { return x.trim(); });
      if (!p[0]) return;
      out[p[0].toLowerCase()] = { def: p[1] || '', hide: String(p[2] || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean) };
    });
    return out;
  }

  /* ---------- product model ---------- */
  function Prod(d, rule) {
    this.id = d.id; this.handle = d.h; this.title = d.t; this.type = d.ty || ''; this.tags = d.tg || []; this.img = d.i || ''; this.options = d.o || []; this.sel = d.sel;
    this.all = (d.v || []).map(function (a) { return { id: Number(a[0]), price: Number(a[1]) || 0, compare: Number(a[2]) || 0, available: !!a[3], opts: a[4] || [] }; });
    var hide = (rule && rule.hide) || [];
    var pool = this.all.filter(function (v) { var t = v.opts.join(' / ').toLowerCase(); return !hide.some(function (x) { return t.indexOf(x) > -1; }); });
    this.pool = pool.length ? pool : this.all;
    this.handIdx = -1;
    for (var i = 0; i < this.options.length; i++) if (/hand/i.test(this.options[i])) { this.handIdx = i; break; }
  }
  Prod.prototype.byId = function (id) { id = Number(id); return this.all.filter(function (v) { return v.id === id; })[0] || null; };
  Prod.prototype.find = function (ch) {
    var ex = this.pool.filter(function (v) { return ch.every(function (x, i) { return x == null || v.opts[i] === x; }); });
    return ex.filter(function (v) { return v.available; })[0] || ex[0] || null;
  };
  Prod.prototype.values = function (i) { var seen = {}, out = []; this.pool.forEach(function (v) { var x = v.opts[i]; if (x != null && !seen[x]) { seen[x] = 1; out.push(x); } }); return out; };
  Prod.prototype.label = function (v) {
    if (!v) return '';
    var self = this, parts = [];
    v.opts.forEach(function (x, i) {
      var vals = self.values(i); if (vals.length < 2) return;
      if (i === self.handIdx) { parts.push(String(x).replace(/\s*hand$/i, '') + ' hand'); return; }
      /* short values read like the card's select: "Lure 1", "Size XL" */
      var nm = String(self.options[i] || '').replace(/^select (your |the )?/i, '').replace(/^reel /i, '');
      parts.push(nm && vals.every(function (y) { return String(y).length <= 4; }) ? nm + ' ' + x : x);
    });
    return parts.join(' / ');
  };
  Prod.prototype.hand = function (v) { return v && this.handIdx > -1 ? (/left/i.test(v.opts[this.handIdx] || '') ? 'left' : 'right') : ''; };
  Prod.prototype.initial = function (rule) {
    var v = null;
    if (rule && rule.def) {
      var want = rule.def.toLowerCase();
      v = this.pool.filter(function (x) { return x.available && x.opts.join(' / ').toLowerCase() === want; })[0] ||
        this.pool.filter(function (x) { return x.available && x.opts.join(' / ').toLowerCase().indexOf(want) > -1; })[0] || null;
    }
    if (!v) { v = this.byId(this.sel); if (v && (!v.available || this.pool.indexOf(v) < 0)) v = null; }
    if (!v) v = this.pool.filter(function (x) { return x.available; })[0] || this.pool[0] || null;
    var ch = v ? v.opts.slice() : this.options.map(function () { return null; });
    /* 79% of reels ship right-hand: a default variant on the left hand ("Left Hand", "1.8M and Left hand") starts on its
       right-hand twin unless a variant rule says otherwise */
    if (!(rule && rule.def) && v && /\bleft\b/i.test(v.opts.join(' / '))) {
      var want2 = v.opts.map(function (x) { return String(x).replace(/\bleft\b/i, 'right').toLowerCase(); }).join(' / ');
      var tw = this.pool.filter(function (x) { return x.available && x.opts.join(' / ').toLowerCase() === want2; })[0];
      if (tw) ch = tw.opts.slice();
    }
    return ch;
  };
  Prod.prototype.line = function (v, qty, deal) { return { handle: this.handle, product_id: this.id, product_type: this.type, quantity: qty || 1, price: v ? v.price : 0, tags: this.tags, deal: !!deal }; };

  /* ---------- card ---------- */
  function Card(node, B) {
    var self = this;
    this.el = node; this.B = B;
    var d = JSON.parse($('[data-hdzs-bdata]', node).textContent);
    this.handle = d.h;
    this.rule = B.rules[String(d.h).toLowerCase()] || null;
    this.p = new Prod(d, this.rule);
    this.chosen = this.p.initial(this.rule);
    this.btn = $('[data-add]', node); this.now = $('[data-now]', node); this.was = $('[data-was]', node);
    this.ctrls = $$('[data-opt]', node);
    this.ctrls.forEach(function (c) {
      var i = Number(c.getAttribute('data-opt')), vals = self.p.values(i);
      if (c.tagName === 'SELECT') {
        $$('option', c).forEach(function (o) { if (vals.indexOf(o.value) < 0) c.removeChild(o); });   /* values that exist only in hidden variants (e.g. 10 lb braid) */
        on(c, 'change', function () { self.pick(i, c.value); });
      } else {
        $$('button', c).forEach(function (b) {
          if (vals.indexOf(b.getAttribute('data-value')) < 0) { b.disabled = true; return; }
          on(b, 'click', function () { self.pick(i, b.getAttribute('data-value')); });
        });
        on(c, 'keydown', function (e) {
          var d2 = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!d2) return;
          e.preventDefault();
          var bs = $$('button:not([disabled])', c), k = bs.indexOf(document.activeElement), n = bs[(k + d2 + bs.length) % bs.length];
          if (n) { n.focus(); n.click(); }
        });
      }
    });
    on(this.btn, 'click', function () { B.toggle(self); });
  }
  Card.prototype.variant = function () { return this.p.find(this.chosen); };
  Card.prototype.pick = function (i, val) {
    this.chosen[i] = val;
    var v = this.p.find(this.chosen);
    if (!v || v.opts[i] !== val) {   /* combination does not exist → snap the other options to a variant with this value */
      var alt = this.p.pool.filter(function (x) { return x.opts[i] === val && x.available; })[0] || this.p.pool.filter(function (x) { return x.opts[i] === val; })[0];
      if (alt) this.chosen = alt.opts.slice();
    }
    this.sync();
    this.B.variantChanged(this);
  };
  Card.prototype.sync = function () {
    var self = this, v = this.variant(), c = this.B.copy;
    this.ctrls.forEach(function (ctl) {
      var i = Number(ctl.getAttribute('data-opt'));
      if (ctl.tagName === 'SELECT') { if (self.chosen[i] != null && ctl.value !== self.chosen[i]) ctl.value = self.chosen[i]; }
      else $$('button', ctl).forEach(function (b) { var is = b.getAttribute('data-value') === self.chosen[i]; b.setAttribute('aria-checked', is ? 'true' : 'false'); b.classList.toggle('is-on', is); b.tabIndex = is ? 0 : -1; });
    });
    if (v) {
      setText(this.now, money(v.price));
      var cmp = v.compare > v.price;
      this.was.hidden = !cmp; if (cmp) setText(this.was, money(v.compare));
    }
    var out = !v || !v.available, inB = this.B.has(this.handle);
    this.el.classList.toggle('is-out', out && !inB);
    this.el.classList.toggle('is-in', inB);
    this.btn.setAttribute('aria-pressed', inB ? 'true' : 'false');
    this.btn.disabled = out && !inB;
    this.btn.setAttribute('aria-label', (inB ? (c.remove || 'Remove') : out ? (c.out || 'Sold out') : (c.add || 'Add to bundle')) + ': ' + this.p.title);
  };

  /* ---------- builder ---------- */
  function Builder(root) {
    var self = this;
    this.root = root;
    try { this.cfg = JSON.parse($('[data-hdzs-bundle-cfg]', root).textContent); } catch (e) { this.cfg = {}; }
    this.copy = this.cfg.copy || {};
    this.rules = parseRules(this.cfg.rules);
    this.items = [];      /* [{h, id}] grid products, in the order they were added */
    this.pair = null;     /* [id, id] — the Buy 1 Get 1 pair carried over from the quiz (a deal line) */
    this.added = false;
    this.cats = {}; (this.cfg.cats || []).forEach(function (c) { self.cats[c.k] = c.h || []; });
    this.dealCats = this.cfg.dealCats || [];
    this.deal = this.cfg.deal ? new Prod(this.cfg.deal, null) : null;
    this.cards = $$('[data-hdzs-bc]', root).map(function (n) { try { return new Card(n, self); } catch (e) { return null; } }).filter(Boolean);
    this.byHandle = {}; this.byVid = {};
    this.cards.forEach(function (c) { self.byHandle[c.handle] = c; c.p.all.forEach(function (v) { self.byVid[v.id] = c; }); });
    var q = function (s) { return $(s, root); };
    this.panel = q('[data-hdzs-panel]'); this.bar = q('[data-hdzs-bar]'); this.scrim = q('[data-hdzs-scrim]');
    this.lines = q('[data-hdzs-lines]'); this.msg = q('[data-hdzs-msg]'); this.track = q('[data-hdzs-track]'); this.cartNote = q('[data-hdzs-cartnote]');
    this.rows = q('[data-hdzs-rows]'); this.note = q('[data-hdzs-note]'); this.ship = q('[data-hdzs-ship]'); this.count = q('[data-hdzs-count]');
    this.addBtn = q('[data-hdzs-addall]'); this.openBtn = q('[data-hdzs-open]');
    this.addLabel = this.addBtn ? this.addBtn.textContent.trim() : 'Add bundle to cart';
    /* phones: the sheet, its scrim and the bar live in a body-level portal — the theme's <main> is its own stacking context
       (position:relative; z-index:1), so anything fixed inside it would stay under the sticky header */
    var sid = root.getAttribute('data-section-id') || '';
    $$('.hdzs-portal').forEach(function (n) { if (n.getAttribute('data-for') === sid && n.parentNode) n.parentNode.removeChild(n); });
    this.portal = el('div', 'hdzb hdzs-portal'); this.portal.setAttribute('data-for', sid);
    document.body.appendChild(this.portal);
    if (this.scrim) this.portal.appendChild(this.scrim);
    if (this.bar) this.portal.appendChild(this.bar);
    this.home = this.panel ? this.panel.parentNode : null;

    /* restore: the quiz hand-off wins over the saved bundle */
    var fromQuiz = readParam(), list = fromQuiz || load();
    if (list) this.restore(list);
    if (fromQuiz && fromQuiz.length) { var nt = q('[data-hdzs-notice]'); if (nt) nt.hidden = false; save(this.memo()); }
    this.cards.forEach(function (c) { c.sync(); });

    /* chips */
    $$('[data-hdzs-chip]', root).forEach(function (b) { on(b, 'click', function () { self.filter(b.getAttribute('data-hdzs-chip'), true); }); });
    /* "Build it yourself" → the grid, under the sticky header */
    $$('[data-hdzs-gobuild]').forEach(function (a) { on(a, 'click', function (e) { e.preventDefault(); self.scrollToGrid(true); }); });
    /* panel / sheet */
    on(this.openBtn, 'click', function () { self.openSheet(); });
    on(q('[data-hdzs-close]'), 'click', function () { self.closeSheet(); });
    on(this.scrim, 'click', function () { self.closeSheet(); });
    var mqh = function () { if (MQ.matches) self.closeSheet(true); self.paintMode(); self.paintBar(); };
    if (MQ.addEventListener) MQ.addEventListener('change', mqh); else if (MQ.addListener) MQ.addListener(mqh);
    on(this.addBtn, 'click', function () { self.addAll(); });
    /* the phone bar shows while the builder is on screen and something is picked */
    this.inView = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { self.inView = es[0].isIntersecting; self.paintBar(); }, { rootMargin: '0px 0px -72px 0px' }).observe(root);
    }
    on(document, 'hdzs:bundle', function () { if (!self.busy) self.render(); });
    this.paintMode();
    this.render();
  }
  Builder.prototype.has = function (h) { return this.items.some(function (it) { return it.h === h; }); };
  Builder.prototype.memo = function () {
    var out = this.items.map(function (it) { return { id: it.id, q: 1 }; });
    if (this.pair) { if (this.pair[0] === this.pair[1]) out.unshift({ id: this.pair[0], q: 2 }); else { out.unshift({ id: this.pair[1], q: 1 }); out.unshift({ id: this.pair[0], q: 1 }); } }
    return out;
  };
  Builder.prototype.restore = function (list) {
    var self = this, pairIds = [];
    this.items = []; this.pair = null;
    list.forEach(function (x) {
      if (self.deal && self.deal.byId(x.id)) { for (var k = 0; k < (x.q || 1); k++) pairIds.push(Number(x.id)); return; }
      var c = self.byVid[x.id]; if (!c || self.has(c.handle)) return;
      var v = c.p.byId(x.id); if (!v || !v.available) return;
      c.chosen = v.opts.slice(); self.items.push({ h: c.handle, id: v.id });
    });
    if (pairIds.length && this.deal) {
      var a = this.deal.byId(pairIds[0]), b = this.deal.byId(pairIds[1] || pairIds[0]);
      if (a && b && a.available && b.available) this.pair = [a.id, b.id];
    }
  };
  Builder.prototype.dirty = function () {
    if (this.added) { this.added = false; this.paintAddBtn(); }
  };
  Builder.prototype.toggle = function (card) {
    if (this.has(card.handle)) { this.remove(card.handle); return; }
    var v = card.variant(); if (!v || !v.available) return;
    this.items.push({ h: card.handle, id: v.id });
    this.dirty(); card.sync(); this.render(card.handle);
    bump(card.el);
  };
  Builder.prototype.remove = function (h) {
    this.items = this.items.filter(function (it) { return it.h !== h; });
    var c = this.byHandle[h]; if (c) c.sync();
    this.dirty(); this.render();
  };
  Builder.prototype.variantChanged = function (card) {
    if (!this.has(card.handle)) return;
    var v = card.variant(); if (!v) return;
    if (!v.available) { this.remove(card.handle); return; }   /* a sold-out variant never reaches /cart/add.js */
    this.items.forEach(function (it) { if (it.h === card.handle) it.id = v.id; });
    this.dirty(); this.render(card.handle);
  };

  /* lines for the engine + the cart */
  Builder.prototype.engineLines = function () {
    var self = this, out = [];
    if (this.pair && this.deal) this.pair.forEach(function (id) { out.push(self.deal.line(self.deal.byId(id), 1, true)); });
    this.items.forEach(function (it) { var c = self.byHandle[it.h]; if (c) out.push(c.p.line(c.p.byId(it.id), 1, false)); });
    return out;
  };
  Builder.prototype.cartItems = function () {
    var out = [];
    if (this.pair) { if (this.pair[0] === this.pair[1]) out.push({ id: this.pair[0], quantity: 2 }); else { out.push({ id: this.pair[0], quantity: 1 }); out.push({ id: this.pair[1], quantity: 1 }); } }
    this.items.forEach(function (it) { out.push({ id: it.id, quantity: 1 }); });
    return out;
  };

  /* the projection: what the cart will see after adding (items already in the cart count too) */
  Builder.prototype.summary = function () {
    var self = this, eng = E(), gross = 0, bogo = 0, units = 0;
    if (this.pair && this.deal) { var a = this.deal.byId(this.pair[0]), b = this.deal.byId(this.pair[1]); gross += a.price + b.price; bogo += Math.min(a.price, b.price); units += 2; }
    var sale = 0;   /* owner 02.10: show the savings — compare-at savings of the picked items (the BOGO pair counts as its free reel, never twice) */
    this.items.forEach(function (it) { var c = self.byHandle[it.h], v = c && c.p.byId(it.id); if (v) { gross += v.price; units += 1; if (v.compare > v.price) sale += v.compare - v.price; } });
    var st = eng.evaluate(this.engineLines(), { withCart: true });
    var live = eng.state ? eng.state() : {};
    var codeBlock = !!(live && live.blockedByCode);
    var blocked = !st.enabled || st.blockedByBogo || codeBlock;
    var dead = !!(st.tier > 0 && eng.codeState(st.tierCode) === 'dead');
    var can = !!(st.tier > 0 && !blocked && !dead && eng.canProject(st.tierCode));
    var cartOnly = eng.evaluate([], { withCart: true });
    return {
      st: st, gross: gross, bogo: bogo, sale: sale, units: units, lines: this.items.length + (this.pair ? 1 : 0),
      blocked: blocked, codeBlock: codeBlock, foreign: live && live.foreignCode, dead: dead, can: can,
      bundle: can ? st.amount : 0, total: Math.max(0, gross - bogo - (can ? st.amount : 0)),
      cartUnits: cartOnly.blockedByBogo ? 0 : cartOnly.eligibleUnits
    };
  };
  Builder.prototype.message = function (sum) {
    var eng = E(), c = this.copy, st = sum.st, msgs = (eng.cfg && eng.cfg.msgs) || {}, t = eng.tiers || [];
    if (!st.enabled) return '';
    if (st.blockedByBogo) return msgs.bogo || '';
    if (sum.codeBlock) return fill(msgs.code || '', { code: sum.foreign || '' });
    var t1 = t[0], t2 = t[1] || t[0];
    var v = {
      u1: t1 ? t1.units : 2, a1: t1 ? moneyT(eng.usd(t1.amount)) : '', a2: t2 ? moneyT(eng.usd(t2.amount)) : '', min: t2 ? moneyT(eng.usd(t2.min)) : '',
      m1: t1 && t1.min ? moneyT(eng.usd(t1.min)) : '', m2: t2 && t2.min ? moneyT(eng.usd(t2.min)) : '',
      n: st.unitsToNext, s: st.unitsToNext === 1 ? '' : 's', x: money(st.amountToNext), amount: st.nextAmount ? moneyT(st.nextAmount) : ''
    };
    if (st.tier === 0) return st.eligibleUnits === 0 ? fill(c.mEmpty, v) : fill(st.unitsToNext > 0 || !c.mNextX ? c.mNext : c.mNextX, v);   /* price tiers (Rustam 02.10): "Add $12.50 more to save $10" */
    if (st.nextTier) return (sum.can ? fill(c.mSaving, { amount: moneyT(st.amount) }) + ' ' : '') + (st.unitsToNext > 0 ? fill(st.amountToNext > 0 ? c.mNextT2 : c.mNext, v) : fill(c.mNextT2x, v));
    return sum.can ? fill(c.mTop, { amount: moneyT(st.amount) }) : '';
  };

  /* ---------- paint ---------- */
  Builder.prototype.render = function (focusHandle) {
    var self = this, c = this.copy, eng = E(); if (!eng) return;
    var sum = this.summary(), st = sum.st;
    this.sum = sum;
    /* lines + empty slots */
    var ul = this.lines; ul.innerHTML = '';
    if (this.pair && this.deal) {
      var pa = this.deal.byId(this.pair[0]), pb = this.deal.byId(this.pair[1]);
      var h0 = this.deal.hand(pa), h1 = this.deal.hand(pb);
      ul.appendChild(this.lineEl({
        img: this.deal.img, title: this.deal.title + ' ×2', sub: h0 && h1 ? (h0 === h1 ? fill(c.pairBoth, { hand: h0 }) : c.pairMix) : '',
        price: money(pa.price + pb.price - Math.min(pa.price, pb.price)), was: money(pa.price + pb.price), tag: c.pairTag,
        onRemove: function () { self.pair = null; self.dirty(); self.render(); }
      }));
    }
    this.items.forEach(function (it) {
      var cd = self.byHandle[it.h], v = cd && cd.p.byId(it.id); if (!v) return;
      var li = self.lineEl({ img: cd.p.img, title: cd.p.title, sub: cd.p.label(v), price: money(v.price), onRemove: function () { self.remove(it.h); } });
      if (focusHandle === it.h) bump(li);
      ul.appendChild(li);
    });
    for (var k = sum.lines; k < 3; k++) {
      var sl = el('li', 'hdzs-slot');
      sl.innerHTML = '<span class="hdzs-slot__ic">' + icon('plus', 18, 2.5) + '</span>';
      sl.appendChild(el('span', '', c.slot || 'Pick an item'));
      ul.appendChild(sl);
    }
    setText(this.count, sum.units ? (sum.units === 1 ? c.itemOne : fill(c.itemMany, { n: sum.units })) : '');
    /* progress */
    var m = this.message(sum);
    setText(this.msg, m); this.msg.hidden = !m;
    var showTrack = st.enabled && !sum.blocked;
    if (this.track && eng.paintTrack) {
      if (showTrack) eng.paintTrack(this.track, st, { applied: sum.can });   /* not confirmed → reached markers stay plain dots, never the green tick */
      this.track.hidden = !showTrack;   /* a reached tier stays on the bar as a plain dot until the checkout confirms the code */
    }
    var cn = sum.cartUnits > 0 && showTrack ? fill(c.noteCart, { n: sum.cartUnits, s: sum.cartUnits === 1 ? '' : 's' }) : '';
    setText(this.cartNote, cn); this.cartNote.hidden = !cn;
    /* rows */
    this.rows.hidden = sum.lines === 0;
    setText($('[data-hdzs-sub]', this.rows), money(sum.gross));
    var rb = $('[data-hdzs-row-bogo]', this.rows); rb.hidden = !(sum.bogo > 0); setText($('[data-hdzs-bogo]', rb), 'Save ' + money(sum.bogo));
    var ru = $('[data-hdzs-row-bundle]', this.rows); ru.hidden = !(sum.bundle > 0); setText($('[data-hdzs-bundle-v]', ru), 'Save ' + money(sum.bundle));
    var tot = $('[data-hdzs-total]', this.rows); if (tot.textContent !== money(sum.total)) { tot.textContent = money(sum.total); bump(tot); }
    var rs = $('[data-hdzs-row-sale]', this.rows); if (rs) { rs.hidden = !(sum.sale > 0); setText($('[data-hdzs-sale]', rs), 'Save ' + money(sum.sale)); }
    var sb = this.saveBox || (this.saveBox = this.rows.parentNode.querySelector('[data-hdzs-savebox]'));
    if (sb) { var all = sum.sale + sum.bogo + sum.bundle; sb.hidden = !(all > 0 && sum.lines > 0); if (!sb.hidden) setText($('[data-hdzs-save-total]', sb), money(all)); }
    /* honest note: the tier is reached but the checkout has not confirmed the code → no money shown */
    if (!this.noteLock) {
      var ok = this.added && sum.lines === 0;
      var nt = ok ? (c.added || '') : (st.tier > 0 && !sum.blocked && !sum.can && sum.lines > 0) ? (c.noteUnknown || '') : '';
      this.note.className = 'hdzs-note' + (ok ? ' is-ok' : ''); setText(this.note, nt); this.note.hidden = !nt;
    }
    /* free shipping (USD only) */
    var usd = H() && H().currency === 'USD', thr = eng.usd(eng.freeShipUsdCents || 10000), left = thr - sum.total;
    this.ship.hidden = !(usd && sum.lines > 0);
    if (!this.ship.hidden) { this.ship.classList.toggle('is-done', left <= 0); setText($('[data-hdzs-ship-t]', this.ship), left <= 0 ? c.shipDone : fill(c.shipMore, { x: money(left) })); }
    if (this.addBtn && !this.busy) this.addBtn.disabled = sum.lines === 0 && !this.added;
    this.paintBar();
    if (!this.busy && !this.added) save(this.memo());
  };
  Builder.prototype.lineEl = function (o) {
    var li = el('li', 'hdzs-line');
    var fig = el('span', 'hdzs-line__img');
    if (o.img) { var im = document.createElement('img'); im.src = o.img; im.alt = ''; im.width = 56; im.height = 56; im.loading = 'lazy'; fig.appendChild(im); }
    li.appendChild(fig);
    var b = el('span', 'hdzs-line__b');
    b.appendChild(el('span', 'hdzs-line__t', o.title));
    if (o.sub) b.appendChild(el('span', 'hdzs-line__v', o.sub));
    if (o.tag) b.appendChild(el('span', 'hdzs-line__tag', o.tag));
    li.appendChild(b);
    var p = el('span', 'hdzs-line__p');
    p.appendChild(document.createTextNode(o.price));
    if (o.was) p.appendChild(el('s', '', o.was));
    li.appendChild(p);
    var x = el('button', 'hdzs-line__x'); x.type = 'button'; x.setAttribute('aria-label', (this.copy.remove || 'Remove') + ': ' + o.title); x.innerHTML = icon('x', 20, 2.5);
    on(x, 'click', o.onRemove);
    li.appendChild(x);
    return li;
  };
  Builder.prototype.paintBar = function () {
    var sum = this.sum; if (!this.bar || !sum) return;
    var c = this.copy, show = !MQ.matches && this.inView && sum.lines > 0 && !this.sheetOpen;
    this.bar.classList.toggle('is-on', show);
    this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (this.openBtn) this.openBtn.tabIndex = show ? 0 : -1;
    setText($('[data-hdzs-bar-n]', this.bar), (sum.units === 1 ? c.itemOne : fill(c.itemMany, { n: sum.units })) + ' · ' + money(sum.total));
    var sv = $('[data-hdzs-bar-save]', this.bar); sv.hidden = !(sum.bundle > 0); if (sum.bundle > 0) setText(sv, 'Save ' + moneyT(sum.bundle));
    var m = this.message(sum) || (sum.st.tier > 0 && !sum.blocked && !sum.can ? (c.barUnknown || c.noteUnknown) : '');
    setText($('[data-hdzs-bar-m]', this.bar), m);
    var eng = E(), t = (eng && eng.tiers) || [], topT = t[t.length - 1], top = topT ? topT.units : 3;
    var p = sum.blocked ? 0 : (eng && eng.byPrice && topT) ? Math.min(100, Math.round(sum.st.eligibleSubtotal / Math.max(1, eng.usd(topT.min)) * 100))
      : Math.min(100, Math.round(sum.st.eligibleUnits / Math.max(1, top) * 100));
    var f = $('[data-hdzs-bar-fill]', this.bar); f.style.width = p + '%'; f.classList.toggle('is-won', sum.can && sum.st.tier > 0);
  };
  Builder.prototype.paintMode = function () {
    if (!this.panel) return;
    var host = MQ.matches ? this.home : this.portal;
    if (host && this.panel.parentNode !== host) host.appendChild(this.panel);
    if (MQ.matches) { this.panel.removeAttribute('role'); this.panel.removeAttribute('aria-modal'); this.panel.removeAttribute('inert'); }
    else { this.panel.setAttribute('role', 'dialog'); this.panel.setAttribute('aria-modal', 'true'); if (!this.sheetOpen) this.panel.setAttribute('inert', ''); }
  };
  Builder.prototype.openSheet = function () {
    if (MQ.matches || this.sheetOpen) return;
    var self = this;
    this.sheetOpen = true;
    this.panel.removeAttribute('inert');
    this.scrim.hidden = false;
    void this.panel.offsetWidth;
    this.panel.classList.add('is-open'); this.scrim.classList.add('is-on');
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
    if (H() && H().lockScroll) H().lockScroll(true);
    this.release = H() && H().trapFocus ? H().trapFocus(this.panel, { onEscape: function () { self.closeSheet(); }, initial: '[data-hdzs-close]' }) : null;
    this.paintBar();
  };
  Builder.prototype.closeSheet = function (silent) {
    if (!this.sheetOpen) return;
    var self = this;
    this.sheetOpen = false;
    this.panel.classList.remove('is-open'); this.scrim.classList.remove('is-on');
    setTimeout(function () { if (!self.sheetOpen) { self.scrim.hidden = true; if (!MQ.matches) self.panel.setAttribute('inert', ''); } }, RM ? 0 : 320);
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
    if (H() && H().lockScroll) H().lockScroll(false);
    if (this.release) { var r = this.release; this.release = null; if (silent) { try { r(); } catch (e) { } } else r(); }
    this.paintBar();
  };
  Builder.prototype.filter = function (key, scroll) {
    var list = key === 'all' ? null : (this.cats[key] || []);
    this.cards.forEach(function (c) { c.el.hidden = !!list && list.indexOf(c.handle) < 0; });
    $$('[data-hdzs-chip]', this.root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-hdzs-chip') === key ? 'true' : 'false'); });
    var dl = $('[data-hdzs-dealln]', this.root); if (dl) dl.hidden = !(key === 'all' || this.dealCats.indexOf(key) > -1);
    var chip = $('[data-hdzs-chip="' + key + '"]', this.root);
    if (chip && chip.scrollIntoView && chip.parentNode.scrollWidth > chip.parentNode.clientWidth) { try { chip.parentNode.scrollTo({ left: chip.offsetLeft - 16, behavior: RM ? 'auto' : 'smooth' }); } catch (e) { } }
    if (scroll) this.scrollToGrid(false);
  };
  /* put the chips right under the sticky header (only scrolls when the grid top is above that line, or when asked) */
  Builder.prototype.scrollToGrid = function (always) {
    var chips = $('[data-hdzs-chips]', this.root); if (!chips) return;
    var main = $('.hdzs-bb__main', this.root) || chips;
    var top = main.getBoundingClientRect().top + window.scrollY - headerH() - 4;
    if (!always && window.scrollY <= top + 1) return;
    window.scrollTo({ top: Math.max(0, top), behavior: RM ? 'auto' : 'smooth' });
  };
  Builder.prototype.paintAddBtn = function () {
    var b = this.addBtn; if (!b) return;
    b.classList.toggle('is-done', this.added);
    if (this.added) b.innerHTML = icon('check', 22, 3) + '<span>' + (this.copy.ctaDone || 'Added — view cart').replace(/[<>&]/g, '') + '</span>';
    else b.textContent = this.addLabel;
  };

  /* ---------- add the whole bundle: one /cart/add.js → engine tier code → UpCart ---------- */
  function upcartOpen() {
    var p = Promise.resolve();
    try { if (typeof window.upcartRefreshCart === 'function') { var r = window.upcartRefreshCart(); if (r && r.then) p = r.catch(function () { }); } } catch (e) { }
    return p.then(function () { try { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); else if (H()) H().cart.open(); } catch (e) { } });
  }
  /* wait until the engine has written (or decided not to write) the tier code for the new cart — max 3.5 s */
  function settleEngine() {
    var eng = E(), hz = H(), cart = hz && hz.cart.state;
    if (!eng || !cart) return Promise.resolve();
    var st = eng.evaluate([], { withCart: true });
    var codes = (cart.discount_codes || []).map(function (d) { return { code: String(d.code).toUpperCase(), ok: !!d.applicable }; });
    var ours = (eng.tiers || []).map(function (t) { return t.code; });
    var foreign = codes.some(function (d) { return ours.indexOf(d.code) < 0; });
    var have = codes.filter(function (d) { return d.code === st.tierCode; })[0];
    if (!st.enabled || st.blockedByBogo || foreign) return Promise.resolve();
    if (st.tier === 0 && !codes.some(function (d) { return ours.indexOf(d.code) > -1; })) return Promise.resolve();
    if (have && have.ok) return Promise.resolve();
    if (st.tier > 0 && eng.codeState(st.tierCode) === 'dead') return Promise.resolve();   /* refused < 1 h ago → the engine will not re-ask */
    return new Promise(function (res) {
      var done = false, t;
      function fin() { if (done) return; done = true; clearTimeout(t); window.removeEventListener('hdzb:discount', onD); res(); }
      function onD(e) { var d = e.detail || {}; if (d.applied || !d.code) setTimeout(fin, 120); }
      window.addEventListener('hdzb:discount', onD);
      t = setTimeout(fin, 3500);
    });
  }
  Builder.prototype.addAll = function () {
    var self = this, c = this.copy, b = this.addBtn;
    if (this.busy) return;
    if (this.added) { this.closeSheet(true); upcartOpen(); return; }
    var items = this.cartItems();
    if (!items.length || !E()) return;
    this.busy = true; this.noteLock = true;
    b.disabled = true; b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
    b.innerHTML = '<span class="hdzs-spin" aria-hidden="true"></span><span>' + String(c.ctaBusy || 'Adding…').replace(/[<>&]/g, '') + '</span>';
    E().addSet(items, { open: false, toast: false, attributes: { _hdzs_source: 'builder' } })   /* 06.10: order attribute → Flow tag «Bundle Builder» → report */
      .then(function () { return settleEngine(); })
      .then(function () {
        /* the bundle is in the cart now: the builder starts clean (no double counting with the cart), the button opens the cart */
        self.busy = false; self.added = true; self.noteLock = false;
        self.items = []; self.pair = null; save(null);
        self.cards.forEach(function (cd) { cd.sync(); });
        b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); b.disabled = false; self.paintAddBtn(); bump(b);
        self.render();
        self.closeSheet(true);
        return upcartOpen();
      })
      .catch(function (e) {
        self.busy = false;
        b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); b.disabled = false; self.paintAddBtn();
        /* Shopify's own reason (JSON 4xx, e.g. "only 3 left") is shown; a rate limit or a non-JSON answer (HTML 429 page,
           network) gets plain words — never a parser error */
        var busy = e && (e.status === 429 || e.status === 503 || e.name === 'SyntaxError' || e.name === 'TypeError');
        var msg = busy ? (c.busy429 || c.err) : ((e && e.data && e.message) || c.err || 'Could not add to cart.');
        self.note.className = 'hdzs-note is-err'; self.note.textContent = msg; self.note.hidden = false;
        try { if (H() && H().toast) H().toast(msg, { kind: 'err' }); } catch (x) { }
        setTimeout(function () { self.noteLock = false; }, 8000);
      });
  };

  /* ---------- tier amounts in the heading (USD in Liquid; other currencies painted here) ---------- */
  function paintTiers() {
    var eng = E(); if (!eng || !eng.tiers) return;
    $$('[data-hdzs-tier-amount]').forEach(function (n) { var t = eng.tiers[Number(n.getAttribute('data-hdzs-tier-amount')) - 1]; if (t && !n.textContent.trim()) n.textContent = 'Save ' + moneyT(eng.usd(t.amount)); });
    $$('[data-hdzs-tier-min]').forEach(function (n) { var t = eng.tiers[Number(n.getAttribute('data-hdzs-tier-min')) - 1]; if (t && !n.textContent.trim()) n.textContent = moneyT(eng.usd(t.min)); });
  }

  function boot() {
    if (!H() || !E()) { setTimeout(boot, 40); return; }
    paintTiers();
    $$('[data-hdzs-bundle]').forEach(function (r) { if (!r.__hdzs) { r.__hdzs = true; try { r.__hdzsBundle = new Builder(r); } catch (e) { if (window.console) console.error('[hdzs] bundle', e); } } });
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
